





















































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import * as _ from "lodash";
import ObjectSelectSearch from "../../components/object-select-search.vue";
import TermMultiSelect from "./multiselect.vue";
import { SaveUser } from "@/request/system";
@Component({
  components: {
    ObjectSelectSearch,
    TermMultiSelect,
  },
})
export default class SystemUserDetail extends Vue {
  @Prop()
  private type: any;
  private user: any = {};
  @Prop()
  private targetUser: any;
  /**
   * @description 关闭窗口
   */
  private close() {
    this.$emit("close");
  }
  /**
   * @description 保存
   */
  private save() {
    // console.log(this.user);
    if (!this.user["用户名"]) {
      this.$message.warning("用户名必须填写");
      return;
    }
    if (!this.user["姓名"]) {
      this.$message.warning("姓名必须填写");
      return;
    }
    if (!this.user["性别"]) {
      this.$message.warning("性别必须填写");
      return;
    }
    if (!this.user["手机号"]) {
      this.$message.warning("手机号必须填写");
      return;
    }
    if (!this.user["状态"]) {
      this.$message.warning("状态必须选择");
      return;
    }
    const loading = this.$loading({ text: "编辑中，请稍后" });
    const params: any = this.user;
    params["国医慧联机构"] = params["四诊设备"];
    SaveUser(this, params)
      .then((data: any) => {
        if (this.type === "add") {
          this.$message.success("保存成功");
        } else {
          this.$message.success("编辑成功");
        }
        this.$emit("refresh");
      })
      .finally(() => {
        loading.close();
      });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    if (this.type === "add") {
      this.user = {
        角色: "普通医生",
        状态: "正常",
        product_id: "",
        专病数据库: [],
        所属机构: [],
        四诊设备: [],
      };
    } else if (this.type === "compose") {
      this.user = _.cloneDeep(this.targetUser);
    }
  }
}
